import { render, staticRenderFns } from "./coper.vue?vue&type=template&id=62c9163b&scoped=true&"
import script from "./coper.vue?vue&type=script&lang=js&"
export * from "./coper.vue?vue&type=script&lang=js&"
import style0 from "./coper.vue?vue&type=style&index=0&id=62c9163b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c9163b",
  null
  
)

export default component.exports